export enum UserRoles {
  GUEST = 'UNCONFIRMED_USER',
  USER = 'USER',
  ADMIN = 'ADMIN',
  SUPPORT = 'SUPPORT',
}

export enum LoadingStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  DONE = 'done',
  ERROR = 'error',
}

export enum AxiosMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum PaginationDirection {
  FORWARD = 'FORWARD',
  BACKWARD = 'BACKWARD',
}
